// extracted by mini-css-extract-plugin
export default {"wrapper":"login-page_wrapper__cTaHy","inside":"login-page_inside__9DgpM","loginBox":"login-page_loginBox__kjc-+"};